import { namespace } from "vuex-class";
import { StoreModule } from "@/store/types";
import { GlobalActions, GlobalGetters } from "@/store/modules/global/types";
import { Component, Vue } from "vue-property-decorator";

@Component
export class Mobile extends Vue {
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetMobile))
  isMobile!: boolean;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddMobile))
  setMobile!: (value: boolean) => Promise<void>;
  @(namespace(StoreModule.Global).Getter(GlobalGetters.GetTablet))
  isTablet!: boolean;
  @(namespace(StoreModule.Global).Action(GlobalActions.AddTablet))
  setTablet!: (value: boolean) => Promise<void>;
}
